import { render, staticRenderFns } from "./info-categories.vue?vue&type=template&id=5db0b249&scoped=true"
import script from "./info-categories.vue?vue&type=script&lang=js"
export * from "./info-categories.vue?vue&type=script&lang=js"
import style0 from "./info-categories.vue?vue&type=style&index=0&id=5db0b249&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0b249",
  null
  
)

export default component.exports